import axios from "axios"
import {
    axiosDefault,
    axiosWAuth
} from "./axios"
import {
    determineApiVersion
} from "@/api/utils.js"
let config = null

class ApiRequest {
    constructor(args) {
        const {
            url = "/", method = "post", payload = null, isAuth = false
        } = args
        this.url = url
        this.method = method
        this.payload = payload
        this.isAuth = isAuth
    }

    run = async () => {
        if (!config) {
            config = await axios.get("./config/runtime.json").then(conf => conf.data)
        }

        if (this.isAuth) {
            return axiosWAuth(config)[this.method](this.url, this.payload && this.payload)
        } else {
            return axiosDefault(config)[this.method](this.url, this.payload && this.payload)
        }
    }
}
export const getProductClasses = async payload => {
    const url = "/api/v2/AdQuery/GetProductClasses";
    const request = new ApiRequest({
      url,
      isAuth: true,
      payload: payload
    });
    const response = await request.run();
    return response.data;
};
export const executeExportAdsQuery = async query => {
    const apiVersion = await determineApiVersion(query.start_date, "ads")
    const url = `/api/v${apiVersion.controllerVersion}/AdQuery/Export`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}

export const getQueryCostPrograms = async payload => {
    const apiVersion = await determineApiVersion(payload.start_date, "programs")
    const url = `/api/v${apiVersion.controllerVersion}/ProgramQuery/QueryCost`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload
    });
    const response = await request.run();
    return response.data;
};
export const deleteSavedSearch = async id => {
    const url = `/api/v1/SavedSearches/DeleteSavedSearch?id=${id}`;
    const request = new ApiRequest({
      url,
      isAuth: true
    });
    const response = await request.run();
    return response.data;
  };
  export const saveSearch = async payload => {
    const url = "/api/v1/SavedSearches/SaveSearch";
    const request = new ApiRequest({
      url,
      isAuth: true,
      payload: payload
    });
    const response = await request.run();
    return response.data;
  };
  export const updateSavedSearch = async payload => {
    const url = "/api/v1/SavedSearches/UpdateSavedSearch";
    const request = new ApiRequest({
      url,
      isAuth: true,
      payload: payload
    });
    const response = await request.run();
    return response.data;
  };
  export const fetchSavedSearches = async (tab) => {
    let url = "/api/v1/SavedSearches/GetSavedSearches";
    if (tab) url = url + `?tab=${tab}`;
    const request = new ApiRequest({
      url,
      isAuth: true,
      method: "get"
    });
    const response = await request.run();
    return response.data;
  };
export const createScheduledReportQuery = async (reportname, payload) => {
    const apiVersion = await determineApiVersion(payload.start_date, "programs")
    const url = `/api/v${apiVersion.controllerVersion}/ScheduledReport/CreateNew?scheduledReportName=${reportname}`;
    const request = new ApiRequest({
      url,
      isAuth: true,
      payload: payload
    });
    const response = await request.run();
    return response.data;
  };


export const getQueryCostSites = async payload => {
    const apiVersion = await determineApiVersion(payload.start_date, "sites")
    const url = `/api/v${apiVersion.controllerVersion}/SiteQuery/QueryCost`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload
    });
    const response = await request.run();
    return response.data;
};

export const getQueryCostAds = async payload => {
    const apiVersion = await determineApiVersion(payload.start_date, "ads")
    const url = `/api/v${apiVersion.controllerVersion}/AdQuery/QueryCost`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload
    });
    const response = await request.run();
    return response.data;
};

export const fetchFormFieldData = async (field, tab) => {
    let url = "/api/v1/" + field
    if (tab) url = url + `?tab=${tab}`
    const request = new ApiRequest({
        url,
        method: "get",
        isAuth: true,
    })
    const response = await request.run()
    return response.data
}

export const getAdvertisers = async payload => {
    const url = "/api/v1/AdSearch/AdvertiserSearch"
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload,
    })
    const response = await request.run()
    return response.data
}
export const getBuyingAgencies = async payload => {
    const url = "/api/v1/AdSearch/BuyingAgencySearch"
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload,
    })
    const response = await request.run()
    return response.data
}

export const getProducts = async payload => {
    const url = "/api/v1/AdSearch/ProductNameSearch"
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload,
    })
    const response = await request.run()
    return response.data
}

export const getFilmCodes = async payload => {
    const url = "/api/v1/AdSearch/FilmCodeSearch"
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: payload,
    })
    const response = await request.run()
    return response.data
}
/*
        different columns available for different views
*/
export const getColumnTypes = async view => {
    const url = `/api/v1/ColumnTypes?view=${view}`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}
export const getMeasures = async view => {
    const url = `/api/v1/Measures?view=${view}`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}
export const getProviders = async tab => {
    const url = `/api/v1/Provider?tab=${tab}`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}

export const getGenres = async () => {
    const url = `/api/v1/Genre`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}

export const executeGenresQuery = async query => {
    const url = `/api/v1/QueryData`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}

export const executeSiteQuery = async query => {
    const apiVersion = await determineApiVersion(query.start_date, "sites")
    const url = `/api/v${apiVersion.controllerVersion}/SiteQuery/MainResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}

export const executeProgramsQuery = async query => {
    const apiVersion = await determineApiVersion(query.start_date, "programs")
    const url = `/api/v${apiVersion.controllerVersion}/ProgramQuery/MainResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const executeProgramsRoFQuery = async query => {
    const url = `/api/v2/ProgramQuery/RoFResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const executeAdsQuery = async query => {
    const apiVersion = await determineApiVersion(query.startDate, "ads")
    const url = `/api/v${apiVersion.controllerVersion}/AdQuery/MainResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const executeAdsRoFQuery = async query => {
    const apiVersion = await determineApiVersion(query.startDate, "ads")
    const url = `/api/v${apiVersion.controllerVersion}/AdQuery/RoFResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const getCategories = async () => {
    const url = "/api/v1/Categories"
    const request = new ApiRequest({
        url,
        isAuth: true,
    })
    const response = await request.run()
    return response.data
}

export const executeExportProgramsQuery = async query => {
    const apiVersion = await determineApiVersion(query.start_date, "programs")
    const url = `/api/v${apiVersion.controllerVersion}/ProgramQuery/Export`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const executeChannelsRoFQuery = async query => {
    const url = `/api/v2/SiteQuery/RoFResult`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}
export const executeExportChannelsQuery = async query => {
    const apiVersion = await determineApiVersion(query.start_date, "sites")
    const url = `/api/v${apiVersion.controllerVersion}/SiteQuery/Export`
    const request = new ApiRequest({
        url,
        isAuth: true,
        payload: query,
    })
    const response = await request.run()
    return response.data
}

export const getOverviewPublishedDate = async () => {
    const url = `/api/v1/Overview/OverviewPublishedDate`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}

export const getTopProgramsLatestDay = async () => {
    const url = `/api/v1/Overview/TopProgramsLatestDay`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}

export const getTopProgramsSevenDays = async () => {
    const url = `/api/v1/Overview/TopProgramsSevenDays`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}

export const getSitesReachSevenDays = async () => {
    const url = `/api/v1/Overview/SitesReachSevenDays`
    const request = new ApiRequest({
        url,
        isAuth: true,
        method: "get",
    })
    const response = await request.run()
    return response.data
}